import { jsx } from 'panel';
import { delayedAttrRemove } from 'panel/build/component-utils/hook-helpers';
import { SelectEl, THEME as SelectElTheme } from 'common/components/select';
import { ItemsMenuEl } from 'common/components/items-menu';
import { InputEl } from 'common/components/input';
import { ButtonBarEl } from 'common/components/button-bar';
import { DropMenuPaneEl } from 'common/components/drop-menu-pane';
import { ToggleEl } from 'common/components/toggle';
import { ContextPanelEl } from 'common/widgets/context-panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { DropMenuEl } from 'common/components/drop-menu';
import { TagInputEl } from 'common/components/tag-input';
import { TagInputTheme } from 'common/components/tag-input/types';
export function template() {
  if (!this.attr("open")) {
    return jsx("div", {
      sel: '.mp-properties-menu'
    });
  } // TODO: do not proxy document.body
  // The issue is we're rendering the dropdown on the page but it's set to "open=false".
  // Therefore the keybindings are still listening even when the menu is closed.


  const keydownProxyEl = this.isNewMenu() || this.hasStagedItem() ? document.body : this.state.keydownProxyEl;

  const CreateItemsMenu = () => {
    return jsx("div", {
      sel: '.create-item-section'
    }, jsx(ButtonEl, {
      sel: '.create-item-btn',
      attrs: {
        icon: "plus",
        theme: ButtonTheme.Tertiary
      },
      on: {
        click: this.helpers.handleCreateButtonClicked
      }
    }), jsx("div", {
      sel: '.create-item-menu'
    }, jsx(DropMenuEl, {
      attrs: {
        open: this.state.createMenuOpen,
        'prevent-close-selectors': [".create-item-btn"]
      },
      on: {
        change: this.helpers.handleCreateMenuChange
      }
    }, jsx(ItemsMenuEl, {
      attrs: {
        sections: this.helpers.getCreateItemSections()
      },
      on: {
        clickItem: this.helpers.onCreateItemClick
      },
      props: {
        keydownProxyEl: this.state.createMenuOpen && keydownProxyEl
      }
    }))));
  };

  const tabs = this.helpers.getToggleTabs();
  const hasTabbedMenu = tabs.length > 1;

  const TabbedHeaderEl = () => {
    return hasTabbedMenu && jsx(ToggleEl, {
      attrs: {
        selected: this.state.selectedTab,
        theme: "tab-bar"
      },
      key: "tabs-".concat(tabs.length),
      on: {
        select: this.helpers.selectOption
      }
    }, tabs.map(tab => // eslint-disable-next-line local-rules/jsx-usage
    jsx("mp-toggle-option", {
      attrs: {
        value: tab.value,
        disabled: tab.disabled
      }
    }, tab.label)));
  };

  const SelectSortingHeaderEl = () => {
    return jsx("div", {
      sel: '.sorting-selector-header'
    }, jsx(SelectEl, {
      attrs: {
        disabled: this.state.loadingEventProperties || this.state.loadingPeopleProperties,
        sections: [{
          items: this.helpers.getSortingOptionSectionItems()
        }],
        theme: SelectElTheme.TERTIARY,
        'always-show-caret': true,
        'menu-width': 120
      },
      on: {
        change: this.helpers.handleSortChange
      }
    }));
  };

  let InnerSearch = null;

  if (this.isNewMenu()) {
    let itemStackForTagSearch = [];

    if (!hasTabbedMenu && this.state.stagedItemsStack) {
      itemStackForTagSearch = this.state.stagedItemsStack.map(item => ({
        label: item.breadcrumbLabel || item.label
      }));
    }

    InnerSearch = jsx("div", {
      sel: '.search-wrapper'
    }, this.hasStagedItem() && jsx(ButtonEl, {
      attrs: {
        icon: "arrow-left",
        theme: ButtonTheme.Tertiary,
        role: "button",
        tabindex: 0
      },
      on: {
        click: this.helpers.unstageProperty
      }
    }), jsx(TagInputEl, {
      attrs: {
        placeholder: "Filter...",
        tags: itemStackForTagSearch,
        theme: TagInputTheme.Breadcrumbs
      },
      props: {
        value: this.state.innerSearchFilter
      },
      on: {
        change: this.helpers.handleTagInputChange
      },
      hook: {
        insert: this.helpers.searchInputInserted
      }
    }), this.helpers.shouldShowCreateItems() && jsx(CreateItemsMenu, null));
  } else if (this.isStagedItemSearchable()) {
    InnerSearch = jsx("div", {
      sel: '.search-wrapper'
    }, jsx(InputEl, {
      attrs: {
        icon: "search",
        placeholder: "Search ".concat(this.helpers.getStagedItemLabel(), "...")
      },
      props: {
        value: this.state.innerSearchFilter
      },
      on: {
        input: this.helpers.handleInnerSearchInput
      },
      hook: {
        insert: this.helpers.searchInputInserted
      }
    }));
  }

  let MenuContent = jsx(null, null, InnerSearch, jsx("div", {
    sel: '.mp-properties-menu-header'
  }, jsx(TabbedHeaderEl, null), this.helpers.hasSelectSortingHeader() && jsx(SelectSortingHeaderEl, null), jsx("slot", {
    attrs: {
      name: "menu-header"
    }
  })), jsx(ItemsMenuEl, {
    attrs: {
      'empty-message': "No items found",
      'search-filter': this.helpers.getSearchFilter(),
      multiple: this.helpers.useMultipleSelection(),
      'show-select-all': this.attr("show-select-all"),
      'select-all-disabled': this.attr("select-all-disabled"),
      'disable-search-sort': this.isNewMenu(),
      'enforce-limit-when-searching': this.isNewMenu()
    },
    on: {
      click: ev => ev.stopPropagation(),
      clickExpanderItem: this.handleExpandItemClick.bind(this),
      clickItem: this.helpers.handleClickItem,
      clickPill: this.helpers.onItemPillClick,
      focusItem: this.helpers.handleFocusItem,
      selectAll: this.helpers.onAllSelected
    },
    props: {
      sections: this.helpers.getMenuSections(),
      keydownProxyEl: !this.state.createMenuOpen && !this.state.modalShowing && keydownProxyEl,
      sectionsFromInputFn: (input, _sections) => this.helpers.sectionsFromInput(input),
      customSearchMatcherFn: this.helpers.customSearchMatcherFn
    },
    hook: {
      insert: this.helpers.handleItemsMenuInsert
    }
  }), this.state.tooltipData && jsx(ContextPanelEl, {
    hook: {
      remove: delayedAttrRemove("tooltip-data", null)
    },
    attrs: {
      'tooltip-data': JSON.stringify(this.state.tooltipData)
    },
    props: {
      tooltipPositionParentElement: this.tooltipPositionParentElement
    },
    on: {
      tooltipContextAction: this.helpers.handleTooltipContextAction,
      tooltipContextEditDescription: this.helpers.handleTooltipContextEditDescription
    }
  }));
  const headerLabel = this.helpers.getHeaderLabel();

  if (!this.isNewMenu() && headerLabel) {
    MenuContent = jsx(DropMenuPaneEl, {
      attrs: {
        header: headerLabel,
        'show-back-button': true
      },
      on: {
        'back-click': this.helpers.unstageProperty
      }
    }, MenuContent);
  }

  const applyButton = !!this.attr("apply-button") && jsx(ButtonBarEl, {
    sel: '.mp-button-bar-primary',
    attrs: {
      role: "button",
      elref: "applyButton",
      disabled: this.attr("apply-button-disabled")
    },
    on: {
      click: this.helpers.onApplyButtonClick
    }
  }, this.attr("apply-button"));
  return jsx("div", {
    sel: '.mp-properties-menu',
    class: {
      'new-menu': this.isNewMenu()
    }
  }, MenuContent, applyButton);
}